import React, { Component, PropTypes } from 'react';
import sortBy from 'lodash/sortBy';

import ChannelListItemStatus from '../containers/ChannelListItemStatus';
import ChannelListItemActions from '../containers/ChannelListItemActions';

import ChannelListItemName from './ChannelListItemName';

export default class ChannelRows extends Component {
  static propTypes = {
    channels: PropTypes.object.isRequired,
    client: PropTypes.string,
    sortValue: PropTypes.oneOf(['alphabetical', 'most-recent']).isRequired,
    teamId: PropTypes.string.isRequired,
  }

  render() {
    const { channels, client, sortValue, teamId } = this.props;

    const borderColor = 'b--black-10';
    const trClasses = `bb-ns ${borderColor}`;
    const tdClasses = 'v-top pt4 pv3-ns f6';

    const channelKeys = Object.keys(channels);
    const channelsArray =
      channelKeys.map((key) => ({ ...channels[key], id: key }));
    let sortedChannels = channelsArray;
    if (sortValue === 'alphabetical') {
      sortedChannels = sortBy(channelsArray, c => c.name && c.name.toLowerCase());
    } else if (sortValue === 'most-recent') {
      sortedChannels = sortBy(channelsArray, ['lastStatusAt']).reverse();
    }

    return (
      <tbody>
        {
          sortedChannels.map(({ id, lastPingAt, name }) => ([
            <tr className={`${trClasses} mt3 mt0-ns`} key={`${id}-top`}>
              <td className={tdClasses}>
                <ChannelListItemName
                  client={client}
                  id={id}
                  name={name}
                />
              </td>
              <td className={`${tdClasses} pr5 dn dtc-ns`}>
                <ChannelListItemStatus
                  channelId={id}
                  teamId={teamId}
                />
              </td>
              <td className={`${tdClasses} w3 tl`}>
                <ChannelListItemActions id={id} lastPingAt={lastPingAt} />
              </td>
            </tr>,
            // TODO find a way to do this without rendering the status twice.
            <tr className={`bb ${borderColor} dn-ns bn-ns`} key={`${id}-bottom`}>
              <td className="pb4" colSpan="2">
                <ChannelListItemStatus
                  channelId={id}
                  teamId={teamId}
                />
              </td>
            </tr>
          ]))
        }
      </tbody>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ChannelRows.jsx
 **/